import React, { useState } from "react";
import { post } from "../../../../services/api";

const PUBLIC_SUPPORT_EMAIL =
  process.env.REACT_APP_PUBLIC_SUPPORT_EMAIL || "support@locallivemusic.io";

const SupportSettings = () => {
  const [supportForm, setSupportForm] = useState({
    type: "bug_report",
    subject: "",
    message: "",
    priority: "medium",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleInputChange = (e) => {
    setSupportForm({
      ...supportForm,
      [e.target.name]: e.target.value,
    });
    setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);
    setSuccess(false);

    try {
      const data = await post("/settings/support", supportForm);

      if (data.success) {
        setSuccess(true);
        setSupportForm({
          type: "bug_report",
          subject: "",
          message: "",
          priority: "medium",
        });

        // Clear success message after 5 seconds
        setTimeout(() => {
          setSuccess(false);
        }, 5000);
      } else {
        setError(data.error || "Failed to submit support request");
      }
    } catch (err) {
      setError("Failed to submit support request. Please try again.");
      console.error("Support request error:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="settings-content">
      <div className="settings-section">
        <div className="section-header">
          <h2 className="section-title">Help & Support</h2>
          <p className="section-subtitle">Get help or send us feedback</p>
        </div>

        {error && (
          <div
            className="alert alert-error"
            style={{
              padding: "10px",
              marginBottom: "20px",
              backgroundColor: "#fee",
              color: "#c33",
              borderRadius: "5px",
            }}
          >
            {error}
          </div>
        )}
        {success && (
          <div
            className="alert alert-success"
            style={{
              padding: "10px",
              marginBottom: "20px",
              backgroundColor: "#efe",
              color: "#3c3",
              borderRadius: "5px",
            }}
          >
            Support request submitted successfully! We'll get back to you
            shortly.
          </div>
        )}

        <div className="settings-card">
          <div className="card-header">
            <h3>Contact Support</h3>
          </div>

          <form onSubmit={handleSubmit} className="support-form">
            <div className="form-grid">
              <div className="input-group">
                <label className="input-label">Request Type</label>
                <select
                  name="type"
                  value={supportForm.type}
                  onChange={handleInputChange}
                  className="settings-select"
                  disabled={isSubmitting}
                >
                  <option value="bug_report">Bug Report</option>
                  <option value="feature_request">Feature Request</option>
                  <option value="general_feedback">General Feedback</option>
                  <option value="account_issue">Account Issue</option>
                  <option value="billing_question">Billing Question</option>
                </select>
              </div>

              <div className="input-group">
                <label className="input-label">Priority</label>
                <select
                  name="priority"
                  value={supportForm.priority}
                  onChange={handleInputChange}
                  className="settings-select"
                  disabled={isSubmitting}
                >
                  <option value="low">Low</option>
                  <option value="medium">Medium</option>
                  <option value="high">High</option>
                  <option value="urgent">Urgent</option>
                </select>
              </div>
            </div>

            <div className="input-group">
              <label className="input-label">Subject</label>
              <input
                type="text"
                name="subject"
                value={supportForm.subject}
                onChange={handleInputChange}
                className="settings-input"
                placeholder="Brief description of your issue"
                required
                disabled={isSubmitting}
              />
            </div>

            <div className="input-group">
              <label className="input-label">Message</label>
              <textarea
                name="message"
                value={supportForm.message}
                onChange={handleInputChange}
                className="settings-textarea"
                placeholder="Please provide detailed information about your issue or request..."
                rows="6"
                required
                disabled={isSubmitting}
              />
            </div>

            <div className="form-actions">
              <button
                type="submit"
                className="submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Sending..." : "Send Support Request"}
              </button>
            </div>
          </form>
        </div>

        <div className="settings-card">
          <div className="card-header">
            <h3>Quick Help</h3>
          </div>

          <div className="help-links">
            <div className="help-item">
              <h4>📖 User Guide</h4>
              <p>Learn how to use Local Live Music effectively</p>
              <a href="#" className="help-link">
                View Guide
              </a>
            </div>

            <div className="help-item">
              <h4>❓ FAQ</h4>
              <p>Find answers to common questions</p>
              <a href="#" className="help-link">
                View FAQ
              </a>
            </div>

            <div className="help-item">
              <h4>📞 Direct Contact</h4>
              <p>Need immediate assistance?</p>
              <a
                href={`mailto:${PUBLIC_SUPPORT_EMAIL}`}
                className="help-link"
              >
                {PUBLIC_SUPPORT_EMAIL}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportSettings;

